// Contient les fonctions et configs de base utilisées par les endpoints
// Chaque fonction fait appel à une fonction fetch commune

import APP_CONFIG from 'config';
import LoggerService,{formatTrace} from '../../LoggerService';



/**
 * Englobe le fetch dans un controller permettant d'abandonner la requete apres un certain delai
 * @param {string} uri
 * @param {object} options
 * @param {number} timeout
 * @returns {Promise}
 */
export const _customFetch = async (uri:string, options:any, timeout:number = APP_CONFIG.FETCH_TIMEOUT):Promise<Response> => {
  const logger = LoggerService.getInstance();
  const URL = APP_CONFIG.API_URL + uri;

  const controller = new AbortController();
  const id = setTimeout(() => {
    controller.abort();
    logger.debug(`ApiEndpoints - _customFetch - Request timed out (${timeout})`, URL);
  }, timeout);
  logger.trace(...formatTrace('ApiEndpoints - _customFetch - Fetching...', URL));
  const response = await fetch(URL, {
    ...options,
    signal: controller.signal
  })
  clearTimeout(id);
  logger.trace(...formatTrace(`ApiEndpoints - _customFetch - Request ${URL} returned`, response));
  return response;
};

/**
 *  Renvoie le json des options d'un fetch GET avec token
 * @param param0
 * @returns
 */
export const getFetchGETOptions = ({accessToken}:{accessToken:string}) => {
  return {
    method: 'GET',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
  };
};

/**
 *  Renvoie le json des options d'un fetch DELETE avec token
 * @param param0
 * @returns
 */
export const getFetchDELETEOptions = ({accessToken}:{accessToken:string}) => {
  return {
    method: 'DELETE',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
  };
}

export interface I_ACCESS_TOKEN_PARAMS {
  accessToken: string;
  page?: number;
}
export interface I_REFRESH_TOKEN_PARAMS {
  refreshToken: string;
}
export interface I_COMMON_DELETE_PARAMS {
  accessToken: string;
  id: number;
}
export interface I_COMMON_GET_ITEM_PARAMS {
  accessToken: string;
  id: number;
}
export interface I_COMMON_CREATE_PARAMS {
  accessToken: string;
}
export interface I_COMMON_PUT_PARAMS {
  accessToken: string;
  id: number;
}
export interface I_COMMON_IMPORT_PARAMS {
  accessToken: string;
  file: File;
}
